import React from "react";
import "./Footer.css"; // Custom CSS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faTwitter,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons"; // Import brand icons
import { library } from "@fortawesome/fontawesome-svg-core";

// Add all icons you plan to use to the library
library.add(
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
  faFacebook,
  faTwitter,
  faInstagram
);

const Footer = () => {
  return (
    <footer className="footer">
      <div className="px-5">
        <div className="row flex justify-content-between ">
          <div className="col-md-5 ">
            <img
              src="/logob.png"
              style={{ height: "50px", width: "100px"}}
              alt="Logo"
              // className="navbar-logo"
              onClick={() =>
                (window.location.href = "https://webdoc.com.pk/")
              }
            />
            <div className="mt-3 fs-6">
              <span>
                WEBDOC's certified doctors provide safe and reliable online
                medical consultations. From remote villages to bustling cities,
                our platform connects you with professional medical assistance
                wherever you are in Pakistan.
              </span>
            </div>
            <div className="mt-3">
              <div className="social-icons row d-flex">
                <a
                  href="https://www.facebook.com/webdoc.com.pk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
                <a
                  href="https://twitter.com/WebDocPk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
                <a
                  href="https://www.instagram.com/webdoc.com.pk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
            </div>
          </div>
          
          <div className="col-md-5 contact-info">
            <h4 className="contact-title">Contact Us</h4>
            <div className="">
              <ul className="contact-list">
                <div className="social-icons">
                  <li>
                    <a
                      href="https://www.google.com/maps/search/?api=1&query=Plot+No.+320%2C+River+View+Commercial%2C+Lily+Road%2C+Phase+7+Bahria+Town%2C+Islamabad%2C+44000"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center text-decoration-none text-dark"
                    >
                      <div className="social-icon">
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                      </div>
                      <span className="ms-2 text-white fs-6">
                        Bahria Town Phase 7, Islamabad, Pakistan
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="tel:+923443333737"
                      className="d-flex align-items-center text-decoration-none text-dark"
                    >
                      <div className="social-icon">
                        <FontAwesomeIcon icon={faPhone} />
                      </div>
                      <span className="ms-2 text-white fs-6">
                        Call Us Now: +92 344 3333737
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      href="mailto:support@webdoc.com.pk"
                      className="d-flex align-items-center text-decoration-none text-dark"
                    >
                      <div className="social-icon">
                        <FontAwesomeIcon icon={faEnvelope} />
                      </div>
                      <span className="ms-2 text-white fs-6">
                        Email Us: support@webdoc.com.pk
                      </span>
                    </a>
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
